<div class="notification">
    <div class="notification__header">
        <div class="row">
            <div class="col-md-6 col-xs-6 col-sm-6 PL-0">
                <h3>{{ "DASHBOARD_FIX_ASSETS.NOTIFICATIONS" | translate }}</h3>
            </div>

            <div class="col-md-6 col-xs-6 col-sm-6 text-right PR-0">
                <a (click)="markAllRead()">{{ "SYSTEM_NAVIGATION.MARK_ALL_AS_READ" | translate }}</a>

                <button class="setting-design" mat-icon-button [matMenuTriggerFor]="messageMenu">
                    <mat-icon>settings</mat-icon>
                </button>

                <mat-menu #messageMenu="matMenu">
                    <button type="button" mat-menu-item>
                        <mat-icon>volume_mute</mat-icon>
                        <span>{{ "SYSTEM_NAVIGATION.MUTE_NOTIFICATION" | translate }}</span>
                    </button>

                    <button type="button" mat-menu-item>
                        <mat-icon>check</mat-icon>
                        <span>{{ "SYSTEM_NAVIGATION.MARK_ALL_AS_READ" | translate }}</span>
                    </button>
                </mat-menu>
            </div>
        </div>
    </div>
    <div *ngIf="notificationsDataSource$ | async as dataSource">
        <ng-container *ngIf="dataSource?.first$ | async as first" [ngSwitch]="first">
            <div *ngSwitchCase="dataSource.searching" class="no-inner-data">
                <h5>
                    {{ "SYSTEM_NAVIGATION.SEARCHING" | translate }}
                </h5>
            </div>
            <div *ngSwitchCase="dataSource.nothing" class="no-inner-data">
                <img src="assets/images/notification.png" alt="">
                <h5>
                    {{
                    "DASHBOARD_FIX_ASSETS.NO_NOTIFICATION"
                    | translate
                    }}
                </h5>
            </div>
            <div *ngSwitchDefault class="notification__body">
                <cdk-virtual-scroll-viewport [itemSize]="7" #cdk class="full">
                    <ul>
                        <li *cdkVirtualFor="let notification of dataSource">
                            <a [ngClass]="{'active': !notification.isRead && !allRead}" *ngIf="!notification.deleted">
                                <div class="notification__left content-row">
                                    <div class="notification__left__profile">
                                        <mat-icon class="notification-icons">notification_important</mat-icon>
                                    </div>

                                    <div class="notification__left__content">
                                        <p>
                                            {{notification.context?.NotificationMessage?.InAppMessage}}
                                            <ng-container *ngIf="notification.context?.NotificationMessage?.Link">
                                                <a
                                                    [href]="getNotificationLink(notification.context.NotificationMessage.Link)">
                                                    <svg _ngcontent-ldi-c32="" width="16" height="12"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path _ngcontent-ldi-c32=""
                                                            d="M10 0L8.59 1.41L12.17 5H0V7H12.17L8.59 10.59L10 12L16 6L10 0Z">
                                                        </path>
                                                    </svg>
                                                </a>
                                            </ng-container>
                                        </p>

                                        <small>{{notification.modified | fromNow}}</small>
                                    </div>
                                </div>

                                <div class="notification__right">
                                    <button color="primary" type="button" mat-icon-button
                                        [matMenuTriggerFor]="notificationMenu">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>

                                    <mat-menu #notificationMenu="matMenu">
                                        <button type="button" mat-menu-item (click)="delete(notification)">
                                            <mat-icon>delete_outline</mat-icon>
                                            <span>{{ "SYSTEM_NAVIGATION.DELETE_NOTIFICATION" | translate }}</span>
                                        </button>

                                        <button type="button" mat-menu-item (click)="markRead(notification)">
                                            <mat-icon>check</mat-icon>
                                            <span>{{ "SYSTEM_NAVIGATION.MARK_AS_READ" | translate }}</span>
                                        </button>
                                    </mat-menu>
                                </div>
                            </a>
                        </li>
                    </ul>
                </cdk-virtual-scroll-viewport>
            </div>
        </ng-container>
        <div class="notification__footer">
            <a>
                {{ "SYSTEM_NAVIGATION.VIEW_ALL" | translate }}
            </a>
        </div>
    </div>
</div>